<template>
  <div style="position: relative; width: 100%">
    <div
      class="elevation-8 included-in-county-search-bar county-menu"
      v-if="showCountyMenu"
      v-click-outside="{
        handler: onClickOutside,
        include: includeOnClickOutside,
      }"
    >
      <v-list nav dense>
        <v-list-item>
          <input class="search-filter-input" placeholder="Search..." v-model="searchFilter">
        </v-list-item>
        <v-list-item-group v-model="counties" multiple>
          <v-list-item v-for="(item, i) in filteredCountyList" :key="i" :value="item">
            <v-list-item-title v-text="item"></v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
    <v-btn
      class="included-in-county-search-bar search-button"
      @click="
        () => {
          this.showCountyMenu = true;
        }
      "
    >
      Geographics
    </v-btn>
  </div>
</template>

<script>

export default {
  name: "CvcCountySearch",
  props: ["value"],
  data() {
    return {
      counties: [],
      showCountyMenu: false,
      searchFilter: ""
    };
  },
  mounted() {
    window.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        this.onClickOutside()
      }
    });
  },

  computed: {
    data() {
      return this.$store.state.acornCodes.acornCodes ?? {}
    },
    sortedCountyList() {
      return [...Object.keys(this.data)].sort()
    },
    filteredCountyList() {
      return this.sortedCountyList.filter(c => c.toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1)
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.counties = newVal;
      },
      immediate: true,
    },
    counties() {
      this.$emit("input", this.counties);
    },
  },
  methods: {
    onClickOutside() {
      this.showCountyMenu = false;
    },
    includeOnClickOutside() {
      let newArray = [];
      this.$el
        .querySelectorAll(".included-in-county-search-bar")
        .forEach((i) => newArray.push(i));
      return newArray;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-button {
  line-height: 44px;
  color: white !important;
  width: 270px;
  height: 44px !important;
  display: block;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  text-transform: none;
  font-size: 18px;
  font-weight: normal;
}
.county-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 60vh;
  z-index: 8;
  overflow: auto;
}
.search-filter-input {
  border:0;
  outline:0;
  text-align: center;
  font-size: 16px;
  width: 100%;
  &:focus {
    outline:none!important;
  }
}
</style>
